import { render, staticRenderFns } from "./DetailedReports.vue?vue&type=template&id=4e2c4f55"
import script from "./DetailedReports.vue?vue&type=script&lang=js"
export * from "./DetailedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports